import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ChatInputBanner from '@/components/ChatInput/ChatInputBanner';
import Text from '@/components/Typography/Text';
import { useChatInputStore } from '@/store';
import useTranslation from '@/hooks/useTranslation';

function ChatInputLargePromptBanner({ level, estimatedTokens = 0, isDetached = false }) {
  const { t } = useTranslation();
  const dismissBanner = useChatInputStore(state => state.dismissBanner);
  const handleClose = useCallback(() => {
    dismissBanner('large-prompt-banner');
  }, [dismissBanner]);

  return (
    <ChatInputBanner
      color="warning"
      level={level}
      isCloseable={true}
      onClose={handleClose}
      isDetached={isDetached}
      useOverlayCloseButton={true}
    >
      <Text size="s">
        {t('chatInput.largePromptWarning', {
          tokens: Math.max(0, estimatedTokens).toLocaleString(),
        })}
      </Text>
    </ChatInputBanner>
  );
}

ChatInputLargePromptBanner.propTypes = {
  level: PropTypes.number,
  estimatedTokens: PropTypes.number,
  isDetached: PropTypes.bool,
};

export default React.memo(ChatInputLargePromptBanner);
